import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')!));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    /**
     * Dummy login (not used here anymore)
     */
    login(email: string, password: string) {
        return this.http.post<any>(`/users/authenticate`, { email, password }).pipe(
            map(user => {
                if (user && user.token) {
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            })
        );
    }

    /**
     * Auto-login using token API
     */
    autoLoginViaTokenAPI(): Promise<boolean> {
        const apiUrl = 'https://demo.lakee1508operation.com/order/zillion/token';
        const body = {
            customerId: '197',
            clientSecret: 'aDm5j99dklsk3hWLc03j323UEYgz224bkldk0903lnxcreekalpohs'
        };

        return this.http.post<any>(apiUrl, body).toPromise().then(res => {
            if (res?.status === 'success' && res.message) {
                const user = { token: res.message }; // construct minimal user object
                sessionStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user as User);
                return true;
            } else {
                return false;
            }
        }).catch(() => false);
    }

    /**
     * Logout the user
     */
    logout() {
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null!);
    }
}